var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.vipCustomer},[_c('div',{class:_vm.$style.container},[_c('VipCustomer',{attrs:{"isH5":"true"},on:{"close":_vm.close,"openUrl":_vm.openUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }